export interface TrackingEvent {
  event: string;
  value: unknown;
  ignorePageId?: boolean;
}
